import React, { useState, useEffect, useContext } from 'react';
import tw from 'twin.macro';
import { DumpertLogoIcon, DumpertSingleDLogoIcon } from 'icons';
import { ModalContext, RouterContext, PreferenceContext } from '../context';
import { AdsContext } from './AdsContext';

/*
  name: 'Billboard', width: 970, height: 250 };
  name: 'leaderboard', width: 728, height: 90 };
  name: 'rectangle', width: 300, height: 250 };
  name: 'rectangle HPA', width: 320, height: 240 };

Mobile
  1 mediumrectangle
  2 fluid
  3 interscroller
  4 mobilelargerectangle

Tablet
  1 billboard
  2 billboardrectangle

Desktop
  1 leaderboardwallpaper
  2 halfpageskyscraper
  3 fluid
  4 largerectangle
*/

export const setAdsHeightPlaceholder = (element) => {
  if (element && element.offsetHeight && element.offsetHeight > 0) {
    element.style.height = element.offsetHeight + 'px';
  }
};

export const TopAds = ({ children, adType, adNumber, collapsed, ...restProps }) => {
  return (
    <div
      {...restProps}
      css={[
        tw`-mx-4 w-screen flex justify-center items-center leading-none text-center md:w-full md:mx-auto md:rounded-lg`,
        !collapsed && tw`h-[250px]`,
      ]}
    >
      {children}
    </div>
  );
};

export const SideBarAds = ({ children, adType, adNumber, collapsed, ...restProps }) => {
  return (
    <div
      css={[
        tw`flex mx-auto justify-center items-center text-center leading-none min-w-[300px] max-w-[350px] overflow-y-hidden`,
        !collapsed && tw`min-h-[250px] py-2 px-1 rounded-lg`,
      ]}
      {...restProps}
    >
      {children}
    </div>
  );
};

export const LazyloadAds = ({ children, adType, adNumber, collapsed, ...restProps }) => {
  return (
    <div
      tw='flex mx-auto justify-center items-center rounded-lg text-center leading-none
    w-[300px] min-h-[250px]
    adsbreak-s:w-[100%] adsbreak-s:min-h-[90px] adsbreak-m:min-h-[250px]'
      {...restProps}
    >
      {children}
    </div>
  );
};

export const FluidAds = ({ children, adType, adNumber, ...restProps }) => (
  <div tw='w-full' {...restProps}>
    {children}
  </div>
);

export const DumpertQuotes = ({ quotesList = [], randomNum = 1, lightTheme = false }) => (
  <div tw='absolute'>
    <div tw='flex-col my-2'>
      <div>
        <DumpertLogoIcon css={[tw`fill-light h-10`, lightTheme && tw`fill-dark opacity-20`]} />
      </div>
      <div tw='w-[300px] adsbreak-m:w-auto text-center mt-3 font-black uppercase text-xl text-dark'>
        <div tw='w-auto bg-brand px-2 py-1'>{(quotesList[randomNum] || {}).label}</div>
      </div>
    </div>
  </div>
);

export const Ads = ({
  Type = TopAds,
  adType,
  adNumber,
  quotesList = [],
  fluidAd = false,
  collapsed,
  ...restProps
}) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const { isModalOverlay } = useContext(ModalContext);
  const { isModalActive } = useContext(RouterContext);
  const [randomNum, setRandomNum] = useState(-1);
  const hidden = isModalActive && !isModalOverlay;
  const lightTheme = theme === 'light';
  const { dispatchKachingSlots } = useContext(AdsContext);

  useEffect(() => {
    if (hidden) {
      return;
    }

    const r = Math.floor(Math.random() * quotesList.length);
    const slot = { adType, adNumber, isModalOverlay };

    dispatchKachingSlots({ type: 'define', payload: slot });
    setRandomNum(r);
    return () => {
      setRandomNum(-1);
      dispatchKachingSlots({ type: 'destroy', payload: slot });
    };
  }, [adType, adNumber, hidden, isModalOverlay]);

  return (
    <>
      {Type !== undefined && randomNum >= 0 && (
        <Type
          css={[
            !fluidAd && tw`flex justify-center text-center`,
            !(Type === TopAds) && !fluidAd && tw`bg-ads bg-opacity-20`,
          ]}
          adType={adType}
          adNumber={adNumber}
          collapsed={collapsed}
          {...restProps}
        >
          <div
            css={[
              tw`w-[fit-content] max-w-[fit-content] flex justify-center items-center`,
              adType === 'native' && tw`w-full max-w-full`,
            ]}
          >
            <div
              className={`ad ad--${adType}`}
              id={`ad_${adType}-${adNumber}`}
              css={[tw`z-10 leading-[0]`, adType === 'native' && tw`w-full h-full`]}
            >
              {!collapsed && !(Type === TopAds) && !fluidAd && (
                <DumpertSingleDLogoIcon
                  css={[
                    tw`mx-auto fill-light h-10 w-10 opacity-10`,
                    lightTheme && tw`fill-dark opacity-20`,
                  ]}
                />
              )}
            </div>
          </div>
          {Type === TopAds && !collapsed && (
            <DumpertQuotes quotesList={quotesList} randomNum={randomNum} lightTheme={lightTheme} />
          )}
        </Type>
      )}
    </>
  );
};
